import { render, staticRenderFns } from "./MdtList.vue?vue&type=template&id=739ee0d8&scoped=true"
import script from "./MdtList.vue?vue&type=script&lang=js"
export * from "./MdtList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739ee0d8",
  null
  
)

export default component.exports